// +---------------------------------------------------------------+
// + EVENTOS                                                       +
// +---------------------------------------------------------------+

// Salva o evento recebido.
export const SAVE_EVENT = "investment/SAVE_EVENT";
export const SNAPSHOT_EVENT = "investment/SNAPSHOT_EVENT";
export const CLEAN_EVENT = "investment/CLEAN_EVENT";
export const CLEAN_ALL_EVENT = "investment/CLEAN_ALL_EVENT";
export const CLEAN_EVENT_BY_INVESTMENT_ID =
  "investment/CLEAN_EVENT_BY_INVESTMENT_ID";
export const CLOSE_POSITION = "investment/CLOSE_POSITION";

export const STRATEGY_GAIN = "investment/STRATEGY_GAIN";
export const STRATEGY_LOSS = "investment/STRATEGY_LOSS";
export const STRATEGY_TIME = "investment/STRATEGY_TIME";

export const SAVE_MASK_EVENT = "investment/SAVE_MASK_EVENT";

// +---------------------------------------------------------------+
// + NOTIFICAÇÕES                                                  +
// +---------------------------------------------------------------+

// Salva a notificação recebida.
export const SAVE_NOTIFICATION = "investment/SAVE_NOTIFICATION";
